import { useState } from 'react'
import MiniHeader from '../../../components/layout/MiniHeader/index'
import Button from '../../../components/common/Button/index'
import Backdrop from '../../../components/common/Backdrop/Backdrop'
import GridTable from '../../../components/common/GridTable/GridTable'
import Card from '../../../components/common/Card/index'
import Typography from '../../../components/common/Typography/index'
import Pagination from '../../../components/common/Pagination/Pagination'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { RiExpandUpDownLine } from 'react-icons/ri'
import { MdOutlineArrowDropDown } from 'react-icons/md'
import GenerateTicketForm from '../../../components/forms/GenerateTicket/GenerateTicketForm'

const Help = () => {
  const [openTicket, setOpenTicket] = useState(false)
  const [selectedTicketStatus, setSelectedTicketStatus] = useState('new')
  const [selectedPriority, setSelectedPriority] = useState('medium')
  const [selectedCategory, setSelectedCategory] = useState('bug')
  const [selectedSource, setSelectedSource] = useState('inApp')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(10)

  const handleRefresh = () => {
    setCurrentPage(1)
  }
  return (
    <>
      <MiniHeader title="Help" />
      <div className="ml-[250px] p-4 max-w-7xl">
        <div className="flex gap-4">
          <Button onClick={() => setOpenTicket(prev => !prev)}>Generate Ticket</Button>
          <Button>Compose</Button>
        </div>
        <Backdrop isOpen={openTicket} onClose={() => setOpenTicket(prev => !prev)}>
          <GenerateTicketForm
            onSubmit={() => setOpenTicket(prev => !prev)}
            selectedTicketStatus={selectedTicketStatus}
            setSelectedTicketStatus={setSelectedTicketStatus}
            selectedPriority={selectedPriority}
            setSelectedPriority={setSelectedPriority}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSource={selectedSource}
            setSelectedSource={setSelectedSource}
          />
        </Backdrop>
        <div className="grid grid-cols-7 gap-4 py-3">
          <Card className="mt-[4px] col-span-2 p-4">
            <div className="flex justify-between">
              <Typography variant="h4">Tickets</Typography>
              <div className="bg-dark flex items-center justify-center w-8 h-8 rounded-full">
                <Typography className="text-white text-base">11</Typography>
              </div>
            </div>
            <div className="flex items-center justify-between py-2">
              <Typography>New(8)</Typography>
              <RiExpandUpDownLine className="text-3xl" />
            </div>
            <div className="flex py-2 justify-between">
              <Typography variant="h4" className="text-secondary">
                Assigned to me
              </Typography>
              <div className="bg-primary flex items-center justify-center w-8 h-8 rounded-full">
                <Typography className="text-white text-base">3</Typography>
              </div>
            </div>
            <div className="flex py-2 justify-between">
              <Typography variant="h4" className="text-secondary">
                My Tickets
              </Typography>
              <div className="bg-primary flex items-center justify-center w-8 h-8 rounded-full">
                <Typography className="text-white text-base">5</Typography>
              </div>
            </div>
          </Card>
          <Card className="col-span-5 mt-[4px]">
            <div className="py-2">
              <Pagination
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                totalItems={10}
                onPageChange={setCurrentPage}
                onRefresh={handleRefresh}
                justify="end"
              />
            </div>
            <div>
              <div className="bg-light px-2 py-2 grid grid-cols-7">
                <div className="col-span-2">
                  <Typography variant="h4">Sender</Typography>
                </div>
                <div className="col-span-4 flex justify-center">
                  <Typography variant="h4">Message</Typography>
                </div>
                <div className="col-span-1 flex justify-end">
                  <Typography variant="h4">Time</Typography>
                </div>
              </div>
              <div className="px-2 py-2 gap-y-4 grid grid-cols-7"></div>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default Help
